module.exports = __webpack_public_path__ + "static/media/NvizionSolutions-Logo-icon.739b9243.png";